import FilteredNoMappingPresentmentList from './FilteredPresentmentList';

interface Props {
  setReload?: () => void;
  reload?: boolean;
}
const NoMappingData = ({}: Props) => {
  const reload = true;
  const filter = {};
  return (
    <section>
      <FilteredNoMappingPresentmentList reload={reload} filter={{ ...filter }} />
    </section>
  );
};

export default NoMappingData;
